import { Link } from "react-router-dom";
import { Globe, Code, Smartphone, Zap, Send, Calculator } from "lucide-react";
import { Manat } from "./PriceBadge";
import { useSite } from "@/context/SiteContext";

const TikTokIcon = ({ size = 20, strokeWidth = 1.6 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5" />
    <path d="M14 3c.4 2.6 2.2 4.4 5 4.6" />
  </svg>
);

export const SERVICES = [
  { Icon: Globe, title: "Veb saytların hazırlanması", text: "Biznes, xidmət və onlayn layihələr üçün müasir veb saytlar." },
  { Icon: Code, title: "Veb tətbiqlər", text: "Kiçik onlayn alətlər, şəxsi kabinetlər, təqvimlər və tapşırıq idarəetmə sistemləri." },
  { Icon: Smartphone, title: "Mobil tətbiqlər", text: "Konkret biznes ehtiyacları üçün mobil tətbiqlər." },
  { Icon: Zap, title: "Rəqəmsal həllər", text: "Proseslərin avtomatlaşdırılması, formalar, kataloqlar və digər faydalı vasitələr." },
  { Icon: Send, title: "Telegram botların yaradılması", text: "Sifariş, müraciət, bildiriş və avtomatlaşdırma üçün funksional Telegram botlar." },
  { Icon: TikTokIcon, title: "TikTok canlı yayım oyunları", text: "Hədiyyələrə və izləyicilərə reaksiya verən interaktiv yayım oyunları (OBS ilə). TikTok üçün ideyalarınızın 80%-ni reallaşdıra bilərik." },
];

export default function Services() {
  const { config } = useSite();
  const prices = config.contacts?.service_prices || [];
  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-24 scroll-mt-16">
      <div className="container-lm">
        <p className="eyebrow">Xidmətlərimiz</p>
        <h2 className="font-display text-3xl sm:text-4xl font-semibold mt-4">Nə təklif edirik?</h2>
        <p className="text-sm text-[#77736B] mt-4 max-w-md leading-relaxed">
          Biznesinizin rəqəmsal dünyada daha güclü olması üçün müxtəlif istiqamətlərdə xidmət göstəririk.
        </p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-12">
          {SERVICES.map(({ Icon, title, text }, i) => (
            <div key={title} data-testid={`service-${i}`}
              className="group relative rounded-2xl bg-white/70 border border-[#171715]/5 p-7 lg:p-8 transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-[0_24px_50px_-30px_rgba(23,23,21,.35)]">
              <span className="absolute top-7 right-7 font-display text-sm text-[#171715]/20">{String(i + 1).padStart(2, "0")}</span>
              <span className="w-12 h-12 rounded-xl bg-[#EEE7DC] flex items-center justify-center transition-colors duration-300 group-hover:bg-[#171715] group-hover:text-[#D6AD62]">
                <Icon size={20} strokeWidth={1.6} />
              </span>
              <h3 className="font-display font-semibold text-[17px] mt-6">{title}</h3>
              <p className="text-sm text-[#77736B] mt-3 leading-relaxed">{text}</p>
              {prices[i] && (
                <p className="mt-5 inline-flex items-baseline gap-1.5 rounded-full bg-[#171715] text-[#F3D592] px-3.5 py-1.5 text-sm" data-testid={`service-price-${i}`}>
                  <span className="font-display font-bold text-base"><Manat text={prices[i]} /></span><span className="text-[#cfc9bd]">-dan başlayır</span>
                </p>
              )}
              {i === 0 && config.calc?.enabled && (
                <Link to="/#calculator" className="mt-4 flex items-center gap-2 text-sm font-semibold text-[#b58a3f] hover:underline" data-testid="service-calc-link">
                  <Calculator size={15} /> Saytınızın qiymətini hesablayın →
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
